export enum ECatalogApiUrl {
  catalog = '/api/catalog',
  category = '/api/catalog/:categoryId',
  categories = '/api/catalog/categories',
  product = '/api/catalog/products/:productId',
  productDocuments = '/api/catalog/products/:productId/documents',
  productDocument = '/api/catalog/products/:productId/documents/:documentId',
  supplierProducts = '/api/catalog/suppliers/:supplierId/products',
}
